'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("itTableRenderer", function (itDefaultConfig, itRowPrecompiler, itRenderingFn, $timeout) {
  // Inject $timeout

  return function itTableRenderer(tableCtrl) {
    var renderer = this,
      ui = tableCtrl.ui,
      $scope = tableCtrl.getScope(),
      displayedRows = [],
      compiledRows = [],
      renderingFn = itRenderingFn(tableCtrl, renderer),
      rowCompiler = new itRowPrecompiler(tableCtrl, renderer);
    renderer.processConfiguration = function (tableConfig) {
      return _.extend({}, angular.copy(itDefaultConfig), tableConfig);
    };
    renderer.getDisplayedRows = function () {
      return displayedRows;
    };
    renderer.getCompiledRows = function () {
      return compiledRows;
    };
    renderer.getActualSource = function () {
      return tableCtrl.getDataSource();
    };
    renderer.getActualLength = function () {
      return tableCtrl.getDataSource().length;
    };
    renderer.clearContent = function (reinit) {
      var row;
      for (var i = 0; i < compiledRows.length; i++) {
        row = compiledRows[i];
        if (row) {
          row.scope() && row.scope().$destroy();
          row.remove();
        }
      }
      rowCompiler.stop();
      tableCtrl.context.pagination = {};
      displayedRows.splice(0, displayedRows.length);
      tableCtrl.ui.contentBody.empty();
      if (reinit) {
        compiledRows = new Array(renderer.getActualLength());
      }
    };
    renderer.getOrCreateRow = function (i) {
      return compiledRows[i] || renderer.createRow(i, false);
    };
    var getRowLinker = function getRowLinker(model) {
      // peut arriver sur le detachement
      if (model == null) {
        return null;
      }
      switch (model.__type__) {
        case 'footer':
          return tableCtrl.linkers.footerRow;
        case 'subtotal':
          return tableCtrl.linkers.subtotalRow;
        default:
          return tableCtrl.linkers.row;
      }
    };
    renderer.createRow = function (i, detach) {
      // console.log("creating row for index = ", i);

      var rowModel = tableCtrl.getDataSource()[i];
      var rowScope = $scope.$new();
      rowScope.model = rowModel;
      rowScope.$index = i;
      rowScope.$first = i === 0;
      rowScope.$last = i === tableCtrl.getDataSource().length - 1;
      rowScope.$middle = !rowScope.$first && !rowScope.$last;
      var row = null;
      var rowLinker = getRowLinker(rowModel);
      if (rowLinker == null) {
        return;
      }
      rowLinker(rowScope, function (_row) {
        row = _row;
        // Add a specific class for subtotal rows
        if (rowModel.__type__ === 'subtotal') {
          row.addClass('it-subtotal-row');
        }
        ui.contentBody.append(row);
        // Apply sticky styles to the newly created row
        $timeout(function () {
          // Wrap in $timeout
          tableCtrl.applyStickyStylesToRow(row);
        }, 0);
      });
      compiledRows[i] = row;
      if (detach) {
        row.detach();
      }
      return row;
    };
    renderer.deleteRow = function (i) {
      var row = compiledRows[i];
      if (!row) {
        return;
      }
      row.scope() && row.scope().$destroy();
      row.remove();
      compiledRows[i] = null;
    };
    renderer.setScrollPosition = function (options) {
      renderingFn(options);
      // reset the row pre-compiler
      rowCompiler.reset(); // TODO : add debounce / throttle on managemennt process restart
    };
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/standard/itTableRenderer.js
// module id = 2817
// module chunks = 13